<div class="min-h-screen bg-gray-50">
  <!-- Header Section -->
  <div class="bg-white shadow-sm border-b border-gray-200 px-4 py-6">
    <div class="max-w-7xl mx-auto">
      <div
        class="flex flex-col md:flex-row md:items-center md:justify-between gap-4"
      >
        <div class="space-y-1">
          <h1 class="text-2xl md:text-3xl font-bold text-gray-900">
            Gerenciamento de Produtos
          </h1>
          <p class="text-gray-600">Gerencie seu catálogo de produtos</p>
        </div>

        <!-- Header Actions -->
        <div class="flex gap-3">
          <button
            class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
            (click)="addProduct()"
            aria-label="Adicionar novo produto"
          >
            <span class="material-icons text-sm mr-2">add</span>
            Novo Produto
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content with Infinite Scroll -->
  <div class="max-w-7xl mx-auto p-4 md:p-6 h-[calc(100vh-200px)]">
    <app-infinite-scroll
      [config]="infiniteScrollConfig"
      [items]="products()"
      [categories]="productCategories"
      [totalItems]="totalProducts"
      [isLoading]="isLoading()"
      [hasMore]="hasMoreProducts"
      (loadMore)="onLoadMore($event)"
      (search)="onSearch($event)"
      (categoryChange)="onCategoryChange($event)"
    >
      <!-- Products Grid -->
      <div
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
      >
        @for (product of products(); track product.id) {
        <div
          class="bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all duration-200 overflow-hidden group"
        >
          <!-- Product Image -->
          <div
            class="aspect-square bg-gradient-to-br from-gray-50 to-gray-100 relative overflow-hidden"
          >
            @if (product.imageUrl) {
            <img
              [src]="product.imageUrl"
              [alt]="product.name"
              class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
            } @else {
            <div class="w-full h-full flex items-center justify-center">
              <span class="material-icons text-gray-400 text-4xl">image</span>
            </div>
            }

            <!-- Stock Badge -->
            <div class="absolute top-3 left-3">
              <span
                class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium shadow-sm"
                [class]="
                  getStockStatus(product.stock) === 'out-of-stock'
                    ? 'bg-red-100 text-red-800 border border-red-200'
                    : getStockStatus(product.stock) === 'low-stock'
                    ? 'bg-yellow-100 text-yellow-800 border border-yellow-200'
                    : 'bg-green-100 text-green-800 border border-green-200'
                "
              >
                {{ product.stock }} {{ product.unit }}
              </span>
            </div>

            <!-- Category Badge -->
            <div class="absolute top-3 right-3">
              <span
                class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200"
              >
                {{ product.category }}
              </span>
            </div>
          </div>

          <!-- Product Info -->
          <div class="p-4 space-y-3">
            <div class="space-y-1">
              <h3
                class="font-semibold text-gray-900 text-sm leading-tight line-clamp-2"
              >
                {{ product.name }}
              </h3>
              <p class="text-xs text-gray-500 line-clamp-2">
                {{ product.description }}
              </p>
              <div class="flex items-center gap-2 text-xs text-gray-400">
                <span>{{ product.brand }}</span>
                <span>•</span>
                <span>{{ product.model }}</span>
                @if (product.sku) {
                <span>•</span>
                <span>SKU: {{ product.sku }}</span>
                }
              </div>
            </div>

            <!-- Price -->
            <div class="flex items-center justify-between">
              <div>
                <div class="text-lg font-bold text-primary-600">
                  {{ product.price | currency : "BRL" : "symbol" : "1.2-2" }}
                </div>
                @if (product.cost) {
                <div class="text-xs text-gray-500">
                  Custo:
                  {{ product.cost | currency : "BRL" : "symbol" : "1.2-2" }}
                </div>
                }
              </div>

              <!-- Status Indicator -->
              <div class="text-right">
                <div
                  class="w-3 h-3 rounded-full"
                  [class]="
                    getStockStatus(product.stock) === 'out-of-stock'
                      ? 'bg-red-500'
                      : getStockStatus(product.stock) === 'low-stock'
                      ? 'bg-yellow-500'
                      : 'bg-green-500'
                  "
                ></div>
              </div>
            </div>

            <!-- Actions -->
            <div
              class="flex justify-between items-center pt-3 border-t border-gray-100"
            >
              <div class="flex space-x-2">
                <button
                  class="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                  (click)="editProduct(product)"
                  aria-label="Editar produto"
                  title="Editar produto"
                >
                  <span class="material-icons text-sm">edit</span>
                </button>
                <button
                  class="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                  (click)="deleteProduct(product)"
                  aria-label="Excluir produto"
                  title="Excluir produto"
                >
                  <span class="material-icons text-sm">delete</span>
                </button>
              </div>

              <button
                class="px-3 py-1 text-xs font-medium text-primary-600 bg-primary-50 hover:bg-primary-100 rounded-lg transition-colors"
                (click)="viewProduct(product)"
                title="Ver detalhes"
              >
                Detalhes
              </button>
            </div>
          </div>
        </div>
        }
      </div>
    </app-infinite-scroll>
  </div>
</div>
